import { FieldError } from 'react-hook-form';
import {
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
  FormDescription,
} from '../../ui/form';
import { cn } from '@/src/utils';

interface FormContentProps {
  label?: string;
  labelClassName?: string;
  defaultMessage?: React.ReactNode;
  error?: FieldError;
  children?: React.ReactNode;
  isRequired?: boolean;
  className?: string;
  direction?: 'horizontal' | 'vertical';
}

export default function FormContent({
  label,
  labelClassName,
  defaultMessage,
  error,
  children,
  isRequired = false,
  direction = 'horizontal',
  className,
}: FormContentProps) {
  return (
    <FormItem
      className={cn(
        'flex min-h-[42px] items-start gap-2 space-y-0 data-[direction=vertical]:flex-col',
        className,
      )}
      data-direction={direction}
    >
      <FormLabel
        className={cn(
          'w-[164px] max-w-[164px] translate-y-2 leading-[150%] data-[direction=vertical]:translate-y-0',
          error ? 'text-black' : '',
          labelClassName,
        )}
        data-direction={direction}
      >
        {label}
        {isRequired && <span className="ml-1 text-red5">*</span>}
      </FormLabel>
      <div
        className="flex min-h-[40px] flex-1 flex-col justify-center gap-2 data-[direction=vertical]:w-full"
        data-direction={direction}
      >
        <FormControl>{children}</FormControl>
        {error ? (
          <FormMessage>{error.message}</FormMessage>
        ) : (
          defaultMessage && <FormDescription>{defaultMessage}</FormDescription>
        )}
      </div>
    </FormItem>
  );
}
